import { render, staticRenderFns } from "./veStuGraduationYxbysEdit.vue?vue&type=template&id=12235ad2&scoped=true"
import script from "./veStuGraduationYxbysEdit.vue?vue&type=script&lang=js"
export * from "./veStuGraduationYxbysEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12235ad2",
  null
  
)

export default component.exports